import React, { useState, useEffect, useRef } from "react";
import {
    Row,
    Col,
    Typography,
    Button,
    message,
    Modal,
    ProTableOt,
    Form,
    useProTableOt,
    DeleteButton,
    Tag
} from "../../ui/ot";
import AuthorisedCategoryForm from "./authorised_category_form";
import { useCRUDController } from "../../ui/classify_structure/CRUDController";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from 'react-router-dom'
import ReactHtmlParser from 'react-html-parser';

const AuthorisedCategoryTable = ({
    keyPrefix = 'koha.authorized_category_management',
    rowKey = "category",
    showAllColumns = true,
    propsShowColumns,
    rowSelectType = 'checkbox',
    defaultSelectkeys = [], //selectkeys
    defaultSelectInfos = [], //selectInfo
    onSelectChange = () => { }, //selectInfo
    permission_level = null, 
}) => {
    const { t } = useTranslation('translation', { keyPrefix })


    const columns = [
        {
            title: t('category'),
            dataIndex: 'category',
            key: 'category',
            sorter: true,
            render: (text, record, index) => {
                return <div>
                    <Link to={`../authorized_category_values_management?category=${ record?.category}`  } style={{ color: 'blue', fontWeight: 'bold' }}>{record?.category}</Link>
                </div>
            }
        },
        {
            title: t('description'),
            dataIndex: 'description',
            key: 'description',
            sorter: true,
            width: 500,
            render: (text, record, index) => {
                return <div style={{ whiteSpace: "break-spaces" }}>
                    {ReactHtmlParser(record?.description)}
                </div>
            }
        },
        {
            title: '',
            key: 'option',
            valueType: 'option',
            render: (text, record, index) => {
                return permission_level === 1 ? <>
                    {
                        !record?.is_system ? <DeleteButton
                            onConfirm={() => {
                                AuthorisedCategoryController.deleteData([{category:record?.category}])
                            }}

                        /> : <Tag>
                            系統參數不可刪除
                        </Tag>}
                </> : <></>
            }
        }

    ];
    const [showColumns, setShowColumns] = useState(propsShowColumns ? propsShowColumns : ['question_and_answer_data', 'title'])

    const [extra_columns, set_extra_columns] = useState([]);
    const actionRef = useRef();
    const [pageSize, setPageSize] = useState(20);
    const [selectedRowKeys, setSelectedRowKeys] = useState(defaultSelectkeys ? defaultSelectkeys : []);
    const [selectedRowsInfo, setSelectedRowsInfo] = useState(defaultSelectInfos ? defaultSelectInfos : []);

    const rowSelection = {
        //不一定都是對id
        onSelectAll: (selected, selectedRows, changeRows) => {
            let select_temp = [...selectedRowKeys];
            let selectRow = [...selectedRowsInfo];
            if (selected) {
                changeRows.forEach((value, key) => {
                    select_temp.push(value?.[rowKey]);
                    selectRow.push(value);
                });
            } else {
                changeRows.forEach((value, key) => {
                    const index = select_temp.indexOf(value?.[rowKey]);
                    select_temp.splice(index, 1);
                    selectRow.splice(index, 1);
                });
            }
            setSelectedRowKeys(select_temp);
            setSelectedRowsInfo(selectRow);
        },
        onSelect: (record, selected, selectedRows, nativeEvent) => {
            let select_temp = [...selectedRowKeys];
            let selectRow = [...selectedRowsInfo];
            if (selected) {
                select_temp.push(record?.[rowKey]);
                selectRow.push(record);
            } else {
                select_temp = select_temp.filter((key) => key !== record?.[rowKey]);
                selectRow = selectRow.filter((row) => row?.[rowKey] !== record?.[rowKey]);
            }
            setSelectedRowKeys((pre) => select_temp);
            setSelectedRowsInfo(selectRow);
        },

    };
    const [modalOpen, setModalOpen] = useState(false);
    const [modalLoading, setModalLoading] = useState(false);

    const [form] = Form.useForm();

    const [axiosMode, setAxiosMode] = useState("get");
    const onCleanSelected = () => {
        setSelectedRowKeys([]);
        setSelectedRowsInfo([]);
    };
    const onFinish = ({ axiosMode, status, values }) => {
        if (status === "success") {
            if (axiosMode === "post") {
                message.success("新增成功");
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "patch") {
                message.success("修改成功");
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "delete") {
                message.success("刪除成功");
                actionRef.current.reloadAndRest();
                setSelectedRowKeys([]);
                setSelectedRowsInfo([]);
            }
        } else if (status === "error") {
            if (axiosMode === "post") {
                message.error("新增失敗");
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "patch") {
                message.error("修改失敗");
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "delete") {
                message.error("刪除失敗");
                actionRef.current.reloadAndRest();
            }
        }
        if (axiosMode !== "get") {
            setModalLoading(false);
            setModalOpen(false);
        }
    };
    const onBefore = ({ axiosMode, status, values }) => {
        setModalLoading(true);
    };
    const setParamsFilter = (obj) => {
        //拿掉值為空或是null 的東西
        return Object.entries(obj).reduce(
            (all, [key, value]) =>
                value === "" ? { ...all } : { ...all, [key]: value },
            {}
        );
    };

    const {
        check,
        setCheck,
        checkAll,
        setOrders,
        custom_filter_key,
    } = useProTableOt({
        columns,
    });
    const AuthorisedCategoryController = useCRUDController({
        apiRoute: "/koha/authorised_values/category", 
        onFinish,
        onBefore
    })

    useEffect(() => {
        checkAll();
    }, []);
    useEffect(() => {
        onSelectChange(selectedRowsInfo)
    }, [selectedRowsInfo])
    return (<Row>

        <Col span={24}>
            <ProTableOt
                formMode={true}
                actionRef={actionRef}
                headerTitle={
                    <>

                    </>
                }
                columns={showAllColumns ? columns : columns.filter((element) => {
                    return showColumns.includes(element?.key)
                })}
                check={check}
                setCheck={setCheck}
                rowKey={rowKey}

                toolBarRender={() => {
                    return []
                }}
                extra_columns={extra_columns}
                set_extra_columns={set_extra_columns}
                manage_columns={false}
                request={async (params = {}, sort, filter) => {
                    setAxiosMode("get");
                    let newParams = {};
                    let order = setOrders(sort);
                    newParams = {
                        ...params, //只有這個範例要有，其他請看你的後端要什麼資料
                        ...newParams,
                        order,
                        size: params?.pageSize,
                        cur_page: params.current,
                        custom_filter_value: params.keyword ?? "",
                        custom_filter_key: custom_filter_key,
                    };
                    newParams = setParamsFilter({
                        ...newParams,
                    });
                    setPageSize(params?.pageSize ?? 20);

                    return AuthorisedCategoryController.getData(newParams);
                    // return []
                }}
                pageSize={pageSize}
                // rowSelection={false}
                rowSelection={
                    {
                        type: rowSelectType,
                        selectedRowKeys: selectedRowKeys,
                        selectedRowsInfo: selectedRowsInfo,
                        setSelectedRowKeys: setSelectedRowKeys,
                        setSelectedRowsInfo: setSelectedRowsInfo,
                        ...rowSelection,
                    }
                }
                propsUseData={() => {
                    return {
                        postData: AuthorisedCategoryController.postData,
                        patchData: (data) => {
                            console.log({
                                data
                            })
                            AuthorisedCategoryController.patchData(data)
                        },
                        deleteData: (data) => {
                            let deleteData = data?.filter((ele) => {
                                return ele?.is_system === 0 
                                // && !ele?.description
                            })
                            if (deleteData) {
                                console.log({ deleteData })
                            }
                            AuthorisedCategoryController.deleteData(deleteData)
                        }
                    }
                }}
                propsPatchProcess={(item) => {
                    return ({
                        ...item,
                        old_category: item?.category,
                        description: item?.description,
                        axiosMode: "patch"
                    })
                }}
                initialValues={{
                    "axiosMode": "post",
                }}
                propsPostOnBefore={(data) => {
                    return {
                        ...data,
                        axiosMode: "post"
                    }
                }}
                PropsPatchForm={<AuthorisedCategoryForm />}
                modalOpen={modalOpen}
                setModalOpen={setModalOpen}
                propsPatch={permission_level === 1 ? true : false}
                // propsDelete={permission_level === 1 ? true : false}
                propsOnlyShowMultipleDelete
                propsPost={permission_level === 1 ? true : false}
                propsWidth={1000}
                scroll={{
                    x: "100%",
                }}
                // isMultipleEdit={false}
            />
        </Col>
    </Row>)

}
const AuthorisedCategory = ({
    keyPrefix = 'koha.authorized_category_management',
    permission_level = null,
}) => {
    return (
        <Row>
            <Col span={24}>
                <AuthorisedCategoryTable
                    keyPrefix={keyPrefix}
                    permission_level={permission_level}
                />
            </Col>
        </Row>

    );
};
export { AuthorisedCategoryTable }
export default AuthorisedCategory;
